<template>
  <div class="animated fadeIn vld-parent custom-100" >
    <b-row>
      <b-col sm="12">
        <searchBar ref="searchBar"
                   :selected-date="currentDate"
                   :bauhof-structure="bhStructure"
                   :is-bauhof-user="true"
                   :on-search="queryData"
                   :has-selects="hasSelects"
                   :cities="cities"
                   :districts="districts"
                   :measures="measures"
                   @clear-selection="$refs.auftraegeTable.clearSelection(); hasSelects = false; $refs.auftraegeTable.indeterminate = false; $refs.auftraegeTable.allSelected = false"
                   @show-map="showMap"
                   @print="print"
                   @list-planing="planList"
        ></searchBar>
      </b-col>
    </b-row>
      <b-tabs content-class="mt-3" style="background: #fbfbfb;" v-model="currentTab">
        <b-tab title="Alle"></b-tab>
        <b-tab title="Auftragsbuch"></b-tab>
        <b-tab title="Mängelmelder" v-if="possibleTabs['mm']"></b-tab>
        <b-tab title="Baumkontrolle" v-if="possibleTabs['bk']"></b-tab>
        <b-tab title="Fast-Task" v-if="possibleTabs['ft']"></b-tab>
        <b-tab title="Spielplatzkontrolle" v-if="possibleTabs['sp']"></b-tab>
        <b-tab title="Straßenkontrolle" v-if="possibleTabs['st']"></b-tab>
        <b-tab title="GPS-Nachweis" v-if="possibleTabs['gps']"></b-tab>
        <b-tab title="Serienaufgaben" v-if="possibleTabs['series']"></b-tab>
        <b-tab title="Touren"></b-tab>
        <!--b-tab title="Serienaufgaben"></b-tab-->
      </b-tabs>
    <b-row class="custom-flex-1 mt-2">
      <b-col sm="12">
        <auftraegeTable ref="auftraegeTable"
                        :all-groups="allGroups" :table-data="data" :show-freigabe="settings.fg_stufe1"
                        @finish-task="onFinishTask"
                        @change-todos="onChangeTodos"
                        @select-changed="(selected) => {hasSelects = selected}"
                        @page-changed="setPage"
        ></auftraegeTable>
      </b-col>
    </b-row>
    <update-todos-dialog ref="update_todos_dialog" @change-todo="(currentPlanning) => {$refs.change_todo.showDialog(currentPlanning)}" @todos-updated="onTodosUpdated"/>
    <change-todo-dialog ref="change_todo" @change-todo="(todo) => {$refs.update_todos_dialog.onChangeTodo(todo)}"></change-todo-dialog>
    <finish-task-dialog ref="finish_task" @finish-task="onFinish"></finish-task-dialog>
    <task-map ref="task_map" @close-map="closeMap" @map_plan="planMap"></task-map>
    <print-list-dialog ref="print_list_dialog" @create-list-planning="printPlanList"/>
    <create-tour-dialog ref="create_tour_dialog" :bauhof-structure="bhStructure" @plan-tour="printPlanList"/>
  </div>
</template>

<script>
import searchBar from '../aufgaben_verwaltung/AufgabenVerwaltungSearchBar.vue'
import auftraegeTable from '../aufgaben/aufgaben_table_bauhof.vue'
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import {
  arrayBufferToBase64,
  decryptAES,
  decryptFile,
  decryptTodos,
  encryptAES,
  encryptServerTodos
} from "@/shared/crypto";
import {DateTime as LuxonDateTime} from "luxon";
import {parseTimestamp} from "@/shared/dates";

import UpdateTodosDialog from "@/views/aufgaben_verwaltung/UpdateTodosDialog.vue";
import ChangeTodoDialog from "@/views/aufgaben_verwaltung/ChangeTodoDialog.vue"
import FinishTaskDialog from "@/views/aufgaben_verwaltung/FinishTaskDialog.vue"
import TaskMap from "@/views/aufgaben_verwaltung/TaskMap.vue";
import PrintListDialog from "@/views/aufgaben_verwaltung/PrintListDialog.vue";
import CreateTaskSeriesDialog from "@/views/aufgaben_verwaltung/CreateTaskSeriesDialog.vue";
import CreateTourDialog from "@/views/aufgaben_verwaltung/CreateTourDialog.vue";


export default {
  name: "AufgabenVerwaltungBauhof",
  components: {
    CreateTourDialog,
    CreateTaskSeriesDialog,
    PrintListDialog,
    TaskMap,
    'searchBar':searchBar, 'auftraegeTable': auftraegeTable, UpdateTodosDialog, ChangeTodoDialog, FinishTaskDialog},
  data() {
    return {
      // SearchbarProps
      selection: [],
      userGroups: [],
      userGroupSelect: undefined,
      data: [],
      currentPage: 1,
      settings: {fg_stufe1: false},
      allGroups: [],
      currentDate: null,
      bhStructure: [],
      aufgabe: null,
      currentTab: 0,
      tabs: ["all", "ab"],
      possibleTabs: {
      "bk": false,
        "ft": false,
        "gps": false,
        "mm": false,
        "sp": false,
        "st": false
      },
      isBauhof: false,
      hasSelects: false,
      cities: [],
      districts: [],
      measures: [],
      query: {
        group: undefined,
        status: "O",
        planned: "A",
        date: LuxonDateTime.local().toISO(),
        dateType: "M",
        searchText: "",
        groupId: 'all',
        city: null,
        district: null,
        measure: null,
        module: 'all',
        page: 1,
      },
      afterFirstQuery: false,
    }
  },
  props:{
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
  },
  watch: {
    currentTab(n, o) {
      if (this.afterFirstQuery) {
        this.$refs.searchBar.searchFilter();
      }
    },
  },
  created() {
    this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
  },
  methods: {
    print() {
      let selection = this.$refs.auftraegeTable.selectedItems();
      console.log(selection)
      selection.sort((a,b) => (a.ziel_datum > b.ziel_datum) ? 1 : ((b.ziel_datum > a.ziel_datum) ? -1 : 0))
      let payload = [];
      for (let i = 0; i < selection.length; i++) {
        payload.push(selection[i].id)
      }
      this.showLoader();
            this.$http.post(
                Server_URL + '/auftragsbuch/print/task_list', payload, {responseType: 'blob'}
            ).then(this.responseOkPrint, this.responseError)
    },
    printPlanList({titel, description, ziel, selectedKostMigr, close_automatic, selectedPlannings, augr, aufisn, legr}) {
      let selection = this.selection;
      selection.sort((a,b) => (a.ziel_datum > b.ziel_datum) ? 1 : ((b.ziel_datum > a.ziel_datum) ? -1 : 0))
      let payload = [];
      for (let i = 0; i < selection.length; i++) {
        payload.push(selection[i].id)
      }
      let req = {
        ids: payload,
        list_name: titel,
        list_description: description,
        list_date: ziel,
        kost_migr: selectedKostMigr.id,
        close_automatic: close_automatic,
        list_allocation: selectedPlannings,
        augr: augr,
        aufisn: aufisn,
        legr: legr,
      }
      this.showLoader();
      this.$http.post(
          Server_URL + '/auftragsbuch/tour', req
      ).then(this.responseOkTour, this.responseError)
    },
    planMap(selection) {
      this.selection = selection;
      this.$refs.create_tour_dialog.showDialog();
    },
    planList() {
      let selection = this.$refs.auftraegeTable.selectedItems();
      let errorClosed = false;
      let errorPlanned = false;
      let errorTour = false;
      for (let i = 0; i < selection.length; i++) {
        if ((selection[i].count_open + selection[i].count_finished) > 0 || selection[i].complete === 10) {
          selection[i]._rowVariant = 'danger';
          errorClosed = selection[i].complete === 10 || errorClosed;
          errorPlanned = (selection[i].count_open + selection[i].count_finished) > 0 || errorPlanned;
        }
        console.log(selection[i])
        if (selection[i].tour_id !== '') {
          selection[i]._rowVariant = 'danger';
          errorTour = true;
        }
      }
      if (errorClosed || errorPlanned || errorTour) {

        let message = "Achtung: "
        if (errorClosed) {
          message += "Sie können keine bereits abgeschlossenen Aufgaben beplanen.\n"
        }
        if (errorPlanned) {
          message += "Sie können keine bereits beplanten Aufgaben einer Tour zuordnen.\n"
        }

        if (errorTour) {
          message += "Sie können keine Tour in eine weitere Tour integrieren.\n"
        }

        this.$bvToast.toast(message, {
          title: 'Planen fehlgeschlagen',
          autoHideDelay: 3000,
          appendToast: false,
          toaster: 'b-toaster-top-center',
          bodyClass: 'toast-pre-wrap'
        })
        return
      }
      this.selection = selection;
      this.$refs.create_tour_dialog.showDialog();
    },
    responseOkPrint(response) {
      this.hideLoader();
      this.$refs.auftraegeTable.clearSelection();
      this.hasSelects = false;
      this.$refs.auftraegeTable.indeterminate = false;
      this.$refs.auftraegeTable.allSelected = false;
      response.blob().then(blob => {
        if (!this.isBauhof) {
          console.log(blob)
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
        } else {
          blob.arrayBuffer().then(binary => {
            try {
              windowsFileService.onFile(
                  arrayBufferToBase64(new Uint8Array(binary)),
                  "AufgabenListe_" + (new Date()).getTime() + ".pdf", // todo add timestamp to name
                  blob.type
              ).then(r => {
                if (r && !r.Success) {
                  console.log(r)
                }
              }).catch(e => {
                console.log(e)
              });
            } catch (e) {
              console.log(e);
            }
          })
        }
      });
    },
    responseOkPrintPlan(response) {
      this.hideLoader();
      this.$refs.auftraegeTable.clearSelection();
      this.hasSelects = false;
      this.$refs.auftraegeTable.indeterminate = false;
      this.$refs.auftraegeTable.allSelected = false;
      response.blob().then(blob => {
        if (!this.isBauhof) {
          console.log(blob)
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
          this.$refs.searchBar.searchFilter();
        } else {
          blob.arrayBuffer().then(binary => {
            try {
              windowsFileService.onFile(
                  arrayBufferToBase64(new Uint8Array(binary)),
                  "AufgabenListe_" + (new Date()).getTime() + ".pdf", // todo add timestamp to name
                  blob.type
              ).then(r => {
                if (r && !r.Success) {
                  console.log(r)
                }
              }).catch(e => {
                console.log(e)
              });
            } catch (e) {
              console.log(e);
            }
            this.$refs.searchBar.searchFilter();
          })
        }
      });
    },
    responseOkTour(response) {
      this.hideLoader();
      if (response.status === 200 ) {
        this.$router.push("/auftraege/auftrag/"+response.body.tour_id);
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },

    closeMap() {
      this.$bvToast.toast('Keine der ausgewählten Aufgaben haben Koordinaten angehängt. Die Karte kann nicht angezeigt werden.', {
        title: 'Keine Koordinaten',
        autoHideDelay: 3000,
        appendToast: false,
        toaster: 'b-toaster-top-center',
      })
    },
    showMap() {
      this.$refs.task_map.showMap(this.$refs.auftraegeTable.selectedItems());
    },
    onFinishTask(aufgabe) {
      this.aufgabe = aufgabe;
      this.$refs.finish_task.showDialog(aufgabe.subject, aufgabe.modul == 'mm')
    },
    onFinish(message) {
      this.showLoader();
      encryptAES(sessionStorage.getItem("aes"), message).then(res => {
        let req = {
          finish_message: res,
          finish_message_plain: message,
        }
        this.$http.post(
            Server_URL + '/auftragsbuch/data/av/finish/' + this.aufgabe.id, req
        ).then(this.responseOkTrap, this.responseError)
      }).catch(e => {
        console.log(e)
        this.hideLoader();
      })
    },
    responseOkTrap(response) {
      this.hideLoader();
      if (response.status === 200 ) {
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].id === this.aufgabe.id) {
            this.data[i].complete = 10;
            this.data[i].completed = "something";
            let status = this.$refs.searchBar.getCurrentType();
            if (status === 'O') {
              this.data.splice(i, 1);
              break;
            }
          }
        }
        this.$refs.auftraegeTable.onSelectChanged(false, '')
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    onTodosUpdated(res) {
      this.showLoader();
      res.key = sessionStorage.getItem("aes");
      encryptServerTodos(res.key, res.todos).then(r => {
        res.todos = r;
        this.$http.post(
            Server_URL + '/auftragsbuch/data/av/todos/'+this.aufgabe.id,
            res
        ).then(this.onTodoResponseOk, this.responseError)
      }).catch(e => {
        console.log(e)
      })
    },
    onTodoResponseOk(response) {
      this.hideLoader();
      if (response.status === 200) {
        let todos = response.body;
        let countFinished = 0;
        let countOpen = 0;
        for (let i = 0; i < todos.length; i++) {
          if (todos[i].is_finished) {
            countFinished += 1;
          } else {
            countOpen += 1;
          }
        }
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].id === this.aufgabe.id) {
            this.data[i].count_open = countOpen;
            this.data[i].count_finished = countFinished;
            if (this.data[i].selected && (this.data[i].count_open + this.data[i].count_finished) === 0) {
              this.data[i]._rowVariant = '';
            }
            break
          }
        }
        this.hideLoader();
      } else {
        window.location = Redirect_500;
      }
    },
    onChangeTodos(aufgabe) {
      this.aufgabe = aufgabe;
      this.showLoader();
      this.$http.get(
          Server_URL+'/auftragsbuch/data/av/todos_auftrag/'+this.aufgabe.id
      ).then(this.responseOkGetTodos, this.responseError)
    },
    responseOkGetTodos(response) {
      if (response.status === 200 ) {
        let todos = response.body;
        decryptTodos(sessionStorage.getItem("aes"), todos).then(res => {
          console.log(res);
          this.$refs.update_todos_dialog.showDialog(this.bhStructure, res, this.aufgabe.description, this.aufgabe.id, this.aufgabe.subject)
          this.hideLoader();
        }).catch(e => {
          console.log(e)
          this.hideLoader()
        })
      } else {
        this.hideLoader()
        window.location = Redirect_500;
      }
    },
    responseOkGet(response) {
      if (response.status === 200 && response.body.status === "ok") {
        this.currentDate = LuxonDateTime.local().toISO();
        this.bhStructure = response.body.data.bh_structure;
        this.possibleTabs = response.body.data.av_defs;
        this.cities = response.body.data.cities;
        this.districts = response.body.data.districts;
        this.measures = response.body.data.measures;
        this.tabs = ["all", "ab"]
        if (this.possibleTabs["mm"]) {
          this.tabs.push("mm")
        }
        if (this.possibleTabs["bk"]) {
          this.tabs.push("bk")
        }
        if (this.possibleTabs["ft"]) {
          this.tabs.push("k5")
        }
        if (this.possibleTabs["sp"]) {
          this.tabs.push("k1")
        }
        if (this.possibleTabs["st"]) {
          this.tabs.push("k3")
        }
        if (this.possibleTabs["gps"]) {
          this.tabs.push("k4")
        }
        if (this.possibleTabs["series"]) {
          this.tabs.push("series")
        }
        this.tabs.push("planning")
        this.$nextTick(() => {
          this.parseQuery()
          this.$refs.searchBar.setQuery(this.query);
          this.queryData(this.query.group, this.query.status,
              this.query.planned,
              this.query.date, this.query.dateType,
              this.query.searchText, this.query.groupId,
              this.query.city, this.query.district,
              this.query.measure);
        })
      } else {
        window.location = Redirect_500;
      }
    },
    parseQuery() {
      let query = this.$route.query;
      if (query.date) {
        this.query = {
          group: query.group,
          status: query.status,
          planned: query.planned,
          date: query.date,
          dateType: query.dateType,
          searchText: query.searchText,
          groupId: query.groupId,
          city: query.city,
          district: query.district,
          measure: query.measure,
          module: query.module,
          page: query.page,
        }
        this.currentTab = this.tabs.indexOf(query.module);
      }
    },
    responseOkFetch(response) {
      this.$refs.auftraegeTable.currentPage = 1;
      this.$refs.searchBar.onFirstSearch();
      if (response.status === 200 && response.body.status === "ok") {
        let data = response.body.data;
        this.decryptData(data);
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    setPage(page) {
      this.query.page = page;
      this.$router.push({query: this.query}).then(() => {}).catch(err => {});
    },
    queryData(group, status, planned, currentDate, dateType, searchText, groupId, city, district, measure) {
      let d = parseTimestamp(new Date(Date.parse(currentDate)), "DD.MM.YYYY")
      d = encodeURIComponent(d)
      let module = this.tabs[this.currentTab];
      this.query = {
        group: group,
        status: status,
        planned: planned,
        date: currentDate,
        dateType: dateType,
        searchText: searchText,
        groupId: groupId,
        city: city,
        district: district,
        measure: measure,
        module: module,
        page: this.query.page,
      }
      this.$router.push({query: this.query}).then(() => {
        this.showLoader();
        this.$http.get(
            Server_URL+'/auftragsbuch/data/av/fetch/'+groupId+
            "?status_type="+status+
            "&planning_state="+planned+
            "&search_text="+searchText+
            "&selected_date_type="+dateType+
            "&selected_start_date="+d+
            "&module="+module+
            "&city="+(city !== null ? city : '')+
            "&district="+(district !== null ? district : '')+
            "&measure="+(measure !== null ? measure : '')
        ).then(this.responseOkFetch, this.responseError)
      }).catch(e => {
        //console.log(e)
      });
    },
    async decryptData(data) {
      // todo make faster/ less import
      for (let i = 0; i < data.length; i++) {
        data[i]._showDetails = true;
        data[i].selected = false;
        data[i]._rowVariant = '';
        try {
          if (data[i].description !== null && data[i].description !== "") {
            data[i].description = await decryptAES(sessionStorage.getItem("aes"), data[i].description);
          }
        } catch (e) {
          //console.log(e)
        }
      }
      this.hideLoader();
      this.data = data;
      console.log(data)
      this.$refs.auftraegeTable.allSelected = false;
      this.$refs.auftraegeTable.indeterminate = false;
      this.hasSelects = false;
      this.$nextTick(() => {
        if (!this.afterFirstQuery) {
          this.$refs.auftraegeTable.changePage(this.query.page);
        }
        this.afterFirstQuery = true;
      })
    },
  },
}
</script>

<style scoped>
  ::v-deep .tab-content {
    display: none !important;
  }

  .bauhof-border {
    border-left: 5px solid #FBFBFB;
    border-right: 5px solid #FBFBFB;
  }

</style>
<style>
.toast-pre-wrap {
  white-space: pre-wrap;
}
</style>
